import React from "react"
import classes from "./howToGeneral.module.scss"
import playMarket from "../../../assets/img/pages/about-us/playmarket.png"
import appStore from "../../../assets/img/pages/about-us/appSrtore.png"
import img1 from "../../../assets/img/pages/how-to/general/1.png"
import { Li, SectionHeading, Ul } from "../uknow/uknowInfoPage"
import styled from "@emotion/styled/macro"

const Section = styled.div`
  padding-block: 15px;
`

const HowToGeneral = (props) => {
  return (
    <div className={"box"}>
      <div className={classes.header}>
        <div className={classes.header__content}>
          <div className="f fdc aic jcc full-width">
            <h2 className={classes.header__heading}>
              Get the mobile App for Apple or Android first, so you can be
              Knowing on the Go
            </h2>
            <div className={classes.btnGroup}>
              <a href="https://play.google.com/store/apps/details?id=com.ks_app">
                <img src={playMarket} alt="Get it on Google Play" />
              </a>
              <a href="https://apps.apple.com/ua/app/knowstory/id1537940521?l=uk">
                <img src={appStore} alt="Available on the App Store" />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/*<div className="box__content">*/}
      {/*  <Section>*/}
      {/*    <SectionHeading>Introduction & Terminology</SectionHeading>*/}
      {/*    <p className={"mb15"}>*/}
      {/*      Knowstory is a dynamic calendaring and communications platform for*/}
      {/*      teaching and learning. With free and paid services, it uses*/}
      {/*      Knowmeets to transform live learning intersection to be highly*/}
      {/*      personalized and flexible. The platform has supporting marketplace*/}
      {/*      function, social groups, events posting, bookmarking, badging,*/}
      {/*      academic standards library, dynamic inventory management, and more.*/}
      {/*    </p>*/}
      {/*    <p className="mb15">*/}
      {/*      Knowstory’s development schedule for 2022-23 includes*/}
      {/*    </p>*/}

      {/*    <Ul>*/}
      {/*      <Li>*/}
      {/*        Refining the Knowmap for keeping track of Knowmeets and Knowmixes*/}
      {/*      </Li>*/}
      {/*      <Li>Completing the user interface for the Master Schedule</Li>*/}
      {/*      <Li>Integration to outside Calendars</Li>*/}
      {/*      <Li>Account sales and elective marketplace products ecommerce</Li>*/}
      {/*      <Li>Single sign-on within Group accounts</Li>*/}
      {/*      <Li>Rostering improvements and integrations</Li>*/}
      {/*      <Li>Analytics and downloadable schedules</Li>*/}
      {/*      <Li>Continued Mobile development to add more functions</Li>*/}
      {/*    </Ul>*/}
      {/*  </Section>*/}

      {/*  <Section>*/}
      {/*    <SectionHeading>The Parts of Knowstory</SectionHeading>*/}
      {/*    <img src={img1} alt="img1" />*/}
      {/*  </Section>*/}

      {/*  <Section>*/}
      {/*    <SectionHeading>Key Terminology</SectionHeading>*/}
      {/*    <div className="mb30">*/}
      {/*      <h4 className="subhead-2 mb15">Invenstory</h4>*/}
      {/*      <p>*/}
      {/*        Invenstory holds records made by users to indicate what learning*/}
      {/*        resources they have made or purchased. When using the Marketplace,*/}
      {/*        any Product can be saved into Invenstory as a Record.*/}
      {/*      </p>*/}
      {/*    </div>*/}
      {/*    <div className="mb30">*/}
      {/*      <h4 className="subhead-2 mb15">Calendar</h4>*/}
      {/*      <p>*/}
      {/*        Calendar operates to show scheduled Knowmeets and events.*/}
      {/*        Alongside of it any Schedule created for the individual learner*/}
      {/*        will show*/}
      {/*      </p>*/}
      {/*    </div>*/}
      {/*    <div className="mb30">*/}
      {/*      <h4 className="subhead-2 mb15">Kourse</h4>*/}
      {/*      <p className={"mb15"}>*/}
      {/*        A Kourse or Course has three meanings in Knowstory*/}
      {/*      </p>*/}
      {/*      <Ul>*/}
      {/*        <Li>*/}
      {/*          As a function of setting up a Knowmeet, a Kourse must be made*/}
      {/*          first so that Knowmeets can accumulate and be tracked under the*/}
      {/*          Kourse*/}
      {/*        </Li>*/}
      {/*        <Li>*/}
      {/*          A course that your company created that you announce in the*/}
      {/*          Marketplace with a tile and its own page*/}
      {/*        </Li>*/}
      {/*        <Li>*/}
      {/*          A Knowmix you created that delivers a series of steps of*/}
      {/*          learning that you do not want limited to members of your group*/}
      {/*          only. You package it into a Product, and it then appears in the*/}
      {/*          Marketplace as well as a free or for-sale item to learners*/}
      {/*        </Li>*/}
      {/*      </Ul>*/}
      {/*    </div>*/}
      {/*    <div className="mb30">*/}
      {/*      <h4 className="subhead-2 mb15">Knowcred</h4>*/}
      {/*      <p>*/}
      {/*        Knowcred is a badging or credentialing function. Users can create*/}
      {/*        different types of badges based on their privilege*/}
      {/*      </p>*/}
      {/*    </div>*/}
      {/*    <div className="mb30">*/}
      {/*      <h4 className="subhead-2 mb15">Knowmap</h4>*/}
      {/*      <p>*/}
      {/*        The Knowmap is home base for learners to see what has been issued*/}
      {/*        to them in their Kourses. Inside any Kourse may be many Knowmeets*/}
      {/*        or Knowmixes. Knowmap is also home base for educators to sequence,*/}
      {/*        release and get reports on learner completions*/}
      {/*      </p>*/}
      {/*    </div>*/}
      {/*    <div className="mb30">*/}
      {/*      <h4 className="subhead-2 mb15">Knowmeet</h4>*/}
      {/*      <p className={"mb15"}>*/}
      {/*        Knowmeets are the “uberization” of learning. This means that,*/}
      {/*        unlike regular calendars of meetings, these can be set to “float”*/}
      {/*        on the calendar until all invited participants hit a link that*/}
      {/*        enrolls them in the meeting. When all participants comply or are*/}
      {/*        cancelled out of the invitation by the convener, the meeting sets*/}
      {/*        in the space and/or virtual conference call link as required, but*/}
      {/*        only in the time held for that purpose.*/}
      {/*      </p>*/}
      {/*      <p className={"mb15"}>*/}
      {/*        Usually a Knowmeet has a task in the instructions to complete*/}
      {/*        before hitting the link to enroll in the meet.*/}
      {/*      </p>*/}
      {/*      <p className={"mb15"}>*/}
      {/*        This unique feature of managing space and time for intersecting*/}
      {/*        teachers and students allows for auto-cohorting based on the*/}
      {/*        student’s pace of study. This could be done within a traditional*/}
      {/*        classroom or have little to no framework like an open online*/}
      {/*        course without set start and end dates.*/}
      {/*      </p>*/}
      {/*      <p className={"mb15"}>*/}
      {/*        Since users may be one-teacher schools all the way up to large*/}
      {/*        districts, options include sophisticated layered calendars to*/}
      {/*        create new master schedules that bracket the Knowmeets.*/}
      {/*      </p>*/}
      {/*      <p className={"mb15"}>*/}
      {/*        A Knowmeet needs some things to be set up prior to creation such*/}
      {/*        as a basic Calendar and a Kourse. Knowmeets can accrue to any one*/}
      {/*        Kourse in order of creation. See Knowmeets info.*/}
      {/*      </p>*/}
      {/*      <p>*/}
      {/*        For more detailed instructions, numerous steps and quizzes, see*/}
      {/*        info on Knowmixes.*/}
      {/*      </p>*/}
      {/*    </div>*/}
      {/*    <div>*/}
      {/*      <h4 className="subhead-2 mb15">Knowmix</h4>*/}
      {/*      <p>*/}
      {/*        A Knowmix is a lesson sequencer that an educator may use to*/}
      {/*        provide many steps, each which may or may not have an embedded set*/}
      {/*        of instructions attachments, links, quizzes, and a Knowmeet for a*/}
      {/*        live lesson at the end of the Step. We recommend one Knowmix per*/}
      {/*        month or per week in each Subject depending on your needs and how*/}
      {/*        many live meetings you will try to intersect into the learning*/}
      {/*        path, how many students will need to convene, and the rest of the*/}
      {/*        overall master schedule*/}
      {/*      </p>*/}
      {/*    </div>*/}
      {/*  </Section>*/}
      {/*</div>*/}
    </div>
  )
}

export default HowToGeneral
